// extracted by mini-css-extract-plugin
export default {"countBlock":"CountBlockMobile_countBlock__Gj41I","disabled":"CountBlockMobile_disabled__lQGFx"};